import React from 'react';
import block from 'bem-cn';
import { useSelector, shallowEqual } from 'react-redux';
import InputDate from 'components/InputDate';

import './DateRangeFilter.scss';

const b = block('date-range-filter');

const DateRangeFilter = ({ startDate, endDate, setStartDate, setEndDate }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);

  const handleStartDateChange = date => {
    const newDate = new Date(date);
    newDate.setHours(0, 0, 0, 0);
    setStartDate(newDate);
  };

  const handleEndDateChange = date => {
    const newDate = new Date(date);
    newDate.setHours(23, 59, 0, 0);
    setEndDate(newDate);
  };

  return (
    <div className={b()}>
      <div className={b('filter-item')}>
        <div className={b('title')}>{`${locale.from}:`}</div>
        <div className={b('date-input')}>
          <InputDate value={startDate} onChange={handleStartDateChange} dateFormat="DD.MM.YYYY HH:mm" showTimeSelect />
        </div>
      </div>
      <div className={b('filter-item')}>
        <div className={b('title')}>{`${locale.to}:`}</div>
        <div className={b('date-input')}>
          <InputDate value={endDate} onChange={handleEndDateChange} dateFormat="DD.MM.YYYY HH:mm" showTimeSelect />
        </div>
      </div>
    </div>
  );
};

export default DateRangeFilter;
